import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';

import styles from './styles';

const PhonePix = () => {
    const [numberPhone, setNumberPhone] = useState('');
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='phonePix.celular'/>} />

            <View style={styles.container}>
                <View style={styles.contentPhone}>
                    <FormattedMessage id='phonePix.numeroCelular'>
                        {placeholder =>
                        <MaskedInputDefault
                            mask="(99) 99999-9999"
                            keyboardType="numeric"
                            value={numberPhone}
                            onValueChange={(value) => setNumberPhone(value)}
                            placeholder={placeholder}
                        />}
                    </FormattedMessage>
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='phonePix.valorTransferencia'/></Text>
                    <Text><FormattedMessage id='phonePix.valorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='phonePix.moeda'/></Text>
                    <Text><FormattedMessage id='phonePix.valorMoedaGPX'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='phonePix.valorDoDia'/></Text>
                    <Text><FormattedMessage id='phonePix.txtGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='phonePix.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='phonePix.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='phonePix.btnContinuar'/>} titlePage={<FormattedMessage id='phonePix.btnConfirmaTransferencia'/>} />
        </>
    );
}

export default PhonePix;